module.exports = __webpack_public_path__ + "static/media/logo.381303e9.png";